import React, {useContext} from 'react';
// リダイレクト(認証期間切れの場合にリダイレクトするため useHistory)
import {useHistory} from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from '@material-ui/core/ListItemText';
import Grid from "@material-ui/core/Grid";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from '@material-ui/core/Switch';

import {ApolloContext} from "../Apollo_Context";
import {ApolloMessage} from "../Apollo_Mesasge";
import {ApolloAxios} from "../Apollo_ApiRequest3";
import {
	apollo_user_option_path,
} from "../Apollo_links";
import { Typography } from '@material-ui/core';
// メッセージ定義
import {
  GetMessage,
  UI_USER_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

interface sideMenuControl {
	setOpen : any;
}

export function ApolloSideMenuControl(props: sideMenuControl) {

	const {state, dispatch} = React.useContext(ApolloContext);
	const [sideMenuControl, setSideMenuControl] = React.useState(state.userprofile.sideMenuControl);
	const {data, setmsg} = useContext(ApolloMessage);
	// リダイレクト(認証期間切れの場合にリダイレクトするため useHistory)
	let history = useHistory();
	  
	// チェックボックスハンドラ
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // 表示用サイドメニューチェック状態更新
		props.setOpen(event.target.checked);
		const menuCheck = event.target.checked ? 1 : 0
    // ユーザー更新
    const userOptionRequest = {
      sideMenuControl: menuCheck,
    }
    let url = `${apollo_user_option_path}${state.userprofile.userId}`;
    ApolloAxios.put(url, userOptionRequest).then((response) => {
      // 操作ログ(成功)
      // resultApi.current = 1;
      setSideMenuControl(menuCheck);
      state.userprofile.sideMenuControl = menuCheck;
    }).catch((err) => {
      // 操作ログ(失敗)
      // resultApi.current = 9;
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_USER_EDIT,"E","6"), data, setmsg, history)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
			
    }).finally(() => {
      // 操作ログ出力(結果)
      // writeLog();
    });
  }

	return (
		<div>
			<Grid container spacing={2}>
				<Grid item xs={12} md={5}>
					<ListItem>
						<ListItemText primary={"サイドメニュー初期表示"}/>
					</ListItem>
				</Grid>
				<Grid item xs={12} md={6}>
					<ListItem>
						<FormControlLabel
							label="全メニュー表示"
							key={state.userprofile.sideMenuControl ? "Loaded" : "Loading"}
							control={
								<Switch
									checked={sideMenuControl ? true : false}
									onChange={(e) => handleChange(e)}
									color="primary" 
								/>
							}
						/>
					</ListItem>
				</Grid>
			</Grid>
		</div>
	)
}